if (!customElements.get("td-video-timestamp")) {
  class TdVideoTimestamp extends HTMLElement {
    constructor() {
      super();
      this.videoElement = this.querySelector("video");
      this.blocks = Array.from(this.querySelectorAll(".td-vt__block"));
      this.audioControl = this.querySelector("[data-video-sound]");
      this.muted = true;
    }

    connectedCallback() {
      if (this.videoElement) {
        this.videoElement.addEventListener("timeupdate", () =>
          this.checkTimestamp()
        );
        const observer = new IntersectionObserver((entries, observer) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              this.videoElement.play();
              observer.disconnect();
            }
          });
        }, { threshold: 0 });
        observer.observe(this);
        if (this.audioControl) {
          this.audioControl.addEventListener("click", () => {
            this.muted = !this.muted;
            this.videoElement.muted = this.muted;
            this.audioControl.classList.toggle("td-vt__video-sound--muted", this.muted);
          });
        }
      }
    }

    checkTimestamp() {
      const currentTime = this.videoElement.currentTime;
      this.blocks.forEach((block, index) => {
        const blockSeconds = parseInt(block.dataset.seconds);

        const nextBlock = this.blocks[index + 1];
        const nextBlockSeconds = nextBlock
          ? parseInt(nextBlock.dataset.seconds)
          : Infinity;

        if (currentTime >= blockSeconds && currentTime < nextBlockSeconds) {
          block.classList.add("td-vt__block--active");
        } else {
          block.classList.remove("td-vt__block--active");
        }
      });
    }
  }

  customElements.define("td-video-timestamp", TdVideoTimestamp);
}
